/**
 *
 * Asynchronously loads the component for UploadPage
 *
 */

import { lazyLoad } from "utils/loadable"

export const UploadPage = lazyLoad(
  () => import("./index"),
  module => module.UploadPage,
)
